<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

const props = defineProps({
  icons: {
    type: Array,
    default: () => []
  },
  major: Array,
  model: Object,
});

const modules = [Pagination];

const swiperOptions = {
  slidesPerView: 1,
  spaceBetween: 10,
  slidesPerGroup: 1,
  loop: true,
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
};
</script>

<template>
  <div class="slideshow-container">
    <div v-if="major === 'Mobilidade Urbana'">
      <swiper
        v-bind="swiperOptions"
        :pagination="{ clickable: true }"
        :modules="modules"
        class="mySwiper">
        <swiper-slide v-for="(icon, index) in icons" :key="index">
          <div class="slide-card">
            <div class="image-wrapper" v-for="image in icon.files">
              <img
                :class="{
                       'navy-color': model.reference === 'Navy',
                       'mint-color' : model.reference === 'Mint',
                       'pink-color' : model.reference === 'Pink',
                       'snow-color' : model.reference === 'Snow',}"
                :src="image.fullUrl" :alt="'Slide ' + index"

              />
            </div>
            <p>{{ icon.name }}</p>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div v-else>
      <swiper
        v-bind="swiperOptions"
        :pagination="{ clickable: true }"
        :modules="modules"
        class="mySwiper">
        <swiper-slide v-for="(icon, index) in icons" :key="index">
          <div class="slide-card">
            <div class="image-wrapper" v-for="image in icon.files">
              <img :src="image.fullUrl" :alt="'Slide ' + index" />
            </div>
            <p>{{ icon.name }}</p>
          </div>
        </swiper-slide>
      </swiper>
    </div>

  </div>
</template>
